module.exports = __webpack_public_path__ + "static/projectBG-9adf62e35aed4520c1d3fed3d6023aec.png";